import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

// The player's main button. While audio is loading or buffering it keeps
// its normal look and icon, and a thin ring circles it - so a slow network
// reads as "working on it" rather than the control greying out.
const PlayPauseButton = ({ isPlaying, busy, onClick, disabled, size = 48, iconSize, sx }) => {
  const ringSize = (typeof size === 'number' ? size : 48) + 8;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      {busy && (
        <CircularProgress
          size={ringSize}
          thickness={1.5}
          aria-label="Loading audio"
          sx={{
            position: 'absolute',
            color: 'primary.main',
            opacity: 0.7,
            pointerEvents: 'none',
            '& .MuiCircularProgress-circle': { strokeLinecap: 'round' },
          }}
        />
      )}
      <IconButton
        aria-label={isPlaying ? 'pause' : 'play'}
        onClick={onClick}
        disabled={disabled}
        sx={{
          height: size,
          width: size,
          minWidth: size,
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          '&:hover': { backgroundColor: 'primary.dark' },
          // Stay on-brand while disabled for loading, just quieter
          '&.Mui-disabled': { backgroundColor: 'primary.main', color: 'primary.contrastText', opacity: 0.75 },
          ...sx,
        }}
      >
        {isPlaying ? <PauseIcon sx={{ fontSize: iconSize }} /> : <PlayArrowIcon sx={{ fontSize: iconSize }} />}
      </IconButton>
    </Box>
  );
};

export default PlayPauseButton;
